const [owner = '', name = ''] = __HQ_REPO__.split('/');

export const REPO = { owner, name, full: __HQ_REPO__ } as const;
export const APP_VERSION = __HQ_VERSION__;
